<app-attendee-header
  class="z-10 sticky top-0 left-0 block"
></app-attendee-header>

<main id="main-content">
  <app-attendee-homepage></app-attendee-homepage>
</main>

<app-attendee-footer></app-attendee-footer>
